import React from 'react';
import './App.css';
import PrinceLogo from './images/Princelogo.png';

function ProfileLoader({ fadeOut }) {
  return (
    <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="profile-ring">
        <img src={PrinceLogo} alt="Profile" className="profile-image" />
      </div>
      <p className="profile-name">Prince Gupta</p>
      <div className="dots">
        <span className="dot active"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );
}

export default ProfileLoader;
